import script from "./ruoli.vue?vue&type=script&setup=true&lang=js"
export * from "./ruoli.vue?vue&type=script&setup=true&lang=js"

import "./ruoli.vue?vue&type=style&index=0&id=7fa82f61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa82f61"]])

export default __exports__